module.exports = __webpack_public_path__ + "img/marker_one_blue1.1c2c7851.png";